import { render } from "./AddPartnerPage.vue?vue&type=template&id=18ccc039&scoped=true"
import script from "./AddPartnerPage.vue?vue&type=script&lang=js"
export * from "./AddPartnerPage.vue?vue&type=script&lang=js"

import "./AddPartnerPage.vue?vue&type=style&index=0&id=18ccc039&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ccc039"]])

export default __exports__